import Vue from 'vue';
import { MutationTree } from 'vuex';
import { BoardsGroupInfo } from '@descomplica/dex-models';

import { BoardsGroupState } from './state';

const mutations: MutationTree<BoardsGroupState> = {
  SET_BOARDS_GROUPS(state, boardsGroups: BoardsGroupInfo[]) {
    if (!boardsGroups) return;

    boardsGroups.forEach(boardsGroup =>
      Vue.set(state.boardsGroups, boardsGroup.id.toString(), {
        ...state.boardsGroups[boardsGroup.id.toString()],
        ...boardsGroup,
      }),
    );
  },
  UPDATE_BOARDS_GROUPS_ENTITY(state, boardsGroup: BoardsGroupInfo) {
    if (!boardsGroup) return;

    Vue.set(state.boardsGroups, boardsGroup.id.toString(), {
      ...state.boardsGroups[boardsGroup.id.toString()],
      ...boardsGroup,
    });
  },
  CLEAN_BOARDSGROUP_STATE(state, boardsGroupId: number) {
    Vue.delete(state.boardsGroups, boardsGroupId.toString());
  },
};

export default mutations;
